import { ensureCustomerLoyaltyInfo } from "../../../../loyalty";

/**
 * CROSS-PLATFORM module — a plain `index.ts`, the same shape as its sibling
 * `../loyaltyRefundEffect`, because nothing in it is platform-specific. Its one dependency,
 * `packages/core/loyalty`'s `ensureCustomerLoyaltyInfo`, resolves on both sides, and so does
 * everything that stamps the state it reads (`saga/pos/customer` converged on 2026-09-05).
 *
 * ⚠️ It was authored as `index.desktop.ts` when the function it calls still lived in
 * `helpers/loyaltyHelper/index.desktop.ts`. That was a fact about where the helper sat, not about
 * the platform; the helper moved to the loyalty flow's adapter in the DM-146 merge and the
 * `.desktop` pin went with it.
 *
 * Registered by BOTH `../index.desktop.ts` and `../index.native.ts` — a listener effect nothing
 * calls typechecks, exports and silently never runs.
 */

/**
 * Listener effect for `saveSaleData`.
 *
 * Loads the customer's loyalty record whenever the sale's customer CHANGES mid-session — attach,
 * swap, or a fresh `customerRefId` arriving on the sale by any route.
 *
 * ⚠️ It cannot catch a customer who was already on the sale before the listener was attached
 * (My Orders' "Edit Items" seeds `saleData` first), which is why `NewOrder` also asks on mount.
 * The two overlap deliberately; `ensureCustomerLoyaltyInfo` de-duplicates them.
 *
 * Everything downstream that reads `customerLoyaltyInfo` — the reward rows in the deals sheet,
 * the redemption panel, the customer summary — is covered by this and needs no fetch of its own.
 */
export const customerLoyaltyFetchEffect = (action: any, listenerApi: any) => {
  const prevSale = listenerApi.getOriginalState()?.saleDataStore?.saleData;
  const currentSale = listenerApi.getState()?.saleDataStore?.saleData;

  const prevCustomerRefId = prevSale?.customerInfo?.customerRefId;
  const currentCustomerRefId = currentSale?.customerInfo?.customerRefId;
  if (!currentCustomerRefId || prevCustomerRefId === currentCustomerRefId) return;

  ensureCustomerLoyaltyInfo(currentSale);
};
